import './App.css';
import MainContent from "./pages/mainContent";
import {useEffect, useState} from "react";
import {Button, Space, Spin, Tabs} from "antd";
import network from "./common/request";
import {dataEncapsulation} from "./viewModel/mainData";
import {isMobile} from "./viewModel/viewModel";

function App() {

    const [selectedMd, setSelectedMd] = useState(null)
    const [mdTypes, setMdTypes] = useState([])
    const [selectedKey, setSelectedKey] = useState("0")
    const [loading, setLoading] = useState(true)

    useEffect(()=> {
        if (mdTypes.length === 0) {
            requestSdkSetup()
        }
    })

    function requestSdkSetup() {
        network.get("/document/info").then((res)=> {
            let mdTypes = dataEncapsulation(res.data.data)
            let selectMd = mdTypes[0]
            let key = mdTypes[0].key
            for (let i = 0; i < mdTypes.length; i++) {
                let item = mdTypes[i]
                if (item.markdown.indexOf(window.location.pathname) !== -1) {
                    selectMd = item
                    key = item.key
                    break
                }
            }
            setSelectedMd(selectMd)
            setMdTypes(mdTypes)
            setSelectedKey(key)
            setLoading(false)
        }).catch((error)=> {

        })
    }

    function selectTypeOnChange(e) {
        for (let i=0; i<mdTypes.length; i++) {
            if (e === mdTypes[i].key) {
                setSelectedMd(mdTypes[i])
                setSelectedKey(i.toString())
                return
            }
        }
    }

    function haveDownload() {
        if (selectedMd === null) {
            return false
        }
        if (selectedMd.key === "18") {
            return false
        }
        return !(selectedMd.label.indexOf("快应用") !== -1 || selectedMd.label.indexOf("隐私") !== -1 || selectedMd.label.indexOf("测试") !== -1 || selectedMd.label.indexOf("合规") !== -1)
    }

    return (
        <Spin spinning={loading} size={"large"}>
            <div classID="App" style={{width: "100vw", height: "100vh"}}>
                {
                    haveDownload()
                        ?
                        <Button onClick={()=>{
                            window.open(selectedMd.download)
                        }} style={{position: "fixed", right: 16, zIndex: 1000, top: 78}} type={"primary"}>下载SDK</Button>
                        :<></>
                }
                <div style={{position: "fixed", width: "100%", backgroundColor: "white", zIndex: 999}}>
                    <Space style={{width: "100%", height: 64}}>
                        <Space>
                            <div style={{
                                fontWeight: 500,
                                marginLeft: 16,
                                display: "flex",
                                alignItems: "center",
                                // fontFamily: "sans-serif",
                                // fontStyle: "oblique",
                                fontSize: 20,
                                // color: "#0944FA",
                            }}>领页SDK
                            </div>
                            <div style={{
                                fontWeight: 500,
                                marginLeft: -6,
                                display: "flex",
                                alignItems: "center",
                                fontSize: 20
                            }}>对接文档
                            </div>
                        </Space>


                        <Tabs size={"small"} style={{
                            fontWeight: 500,
                            color: "#2c3e50",
                            position: "absolute",
                            height: 64,
                            top: 4,
                            right: 24
                        }} tabBarGutter={isMobile() ? 16 : 32} onChange={selectTypeOnChange} activeKey={selectedKey}
                              items={mdTypes}/>
                    </Space>
                    <div style={{width: "100%", height: 1, backgroundColor: 'rgba(242,245,244, 1)'}}></div>
                </div>

                <MainContent mdInfo={selectedMd}></MainContent>
            </div>
        </Spin>
    );
}

export default App;
